import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { CoreService } from '@app/modules/core/services/core.service';

@Component({
  selector: 'app-qr-not-found',
  templateUrl: './qr-not-found.component.html',
  styleUrls: ['./qr-not-found.component.scss']
})
export class QrNotFoundComponent {

  @Input() home: string
  constructor(
    private router: Router,
    public coreService: CoreService
  ) { }

  goHome() {
    this.router.navigateByUrl(this.home)
  }
}
